module.exports = {"460323451":"中沙岛礁"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460323.json
// module id = 2323
// module chunks = 0